import React, { useCallback } from "react";
import { Typography } from "@mui/material";

import { deleteWorkflow } from "../../../../sevices/apiWorkflows";
import FormDialog from "../../../../components/Dialog/FormDialog";
import useMutate from "../../../../hooks/useMutate";

const DeleteWorkflow = ({ handleDeleteClose, showDelete, workflowId }) => {
  
  const { mutate: deleteWorkflowMutate, isPending } = useMutate(deleteWorkflow,["adminWorkflow"],
    () => {},
    () => {
      handleDeleteClose();
    },
    () => {
      handleDeleteClose();
    });

  const handleDeleteWorkflow = useCallback(() => {
    deleteWorkflowMutate(workflowId);
  }, [deleteWorkflowMutate, workflowId]);

  return (
    <FormDialog
      open={showDelete}
      handleClose={handleDeleteClose}
      handleSubmit={handleDeleteWorkflow}
      loading={isPending}
      buttonTxt={"Delete"}
      title={"Confirmation: Delete Confirmation"}
      alignActions={"center"}
      cancelBtn={true}
      fullWidth={true}
    >
      <Typography className="align_text_center mb-2">
        Are you sure you want to delete this item? This action can not be undone
      </Typography>
    </FormDialog>
  );
};

export default React.memo(DeleteWorkflow);
